import React from 'react';
import DroppableColumn from './DroppableColumn';

export default function RowLayout({ rowIndex, rowData, updateRow,deleteRow,onEdit,onDeleteField }) {
  const { layout, columns } = rowData;

  const handleLayoutChange = (e) => {
    const selected = e.target.value;
    const numCols = parseInt(selected);
    const newCols = [[], [], []]; // Always keep 3 for consistency
    for (let i = 0; i < numCols; i++) newCols[i] = columns[i] || [];
    updateRow(rowIndex, { layout: selected, columns: newCols });
  };
  

  return (
    <div className="p-4 mb-2 border rounded shadow bg-white space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-md font-medium text-gray-700">Row {rowIndex + 1}</h3>
        <div className="flex items-center gap-2">
          <label className="text-sm text-gray-600">Layout:</label>
          <select
            value={layout}
            onChange={handleLayoutChange}
            className="border border-gray-300 rounded px-2 py-1 text-sm"
          >
            <option value="1">1 Column</option>
            <option value="2">2 Columns</option>
            <option value="3">3 Columns</option>
          </select>

          <button
            onClick={() => deleteRow(rowIndex)}
            className="text-red-500 hover:text-red-700 text-sm"
            title="Delete Row"
          >
            🗑
          </button>
        </div>
      </div>

      <div className={`grid gap-4 ${layout === '1' ? 'grid-cols-1' : layout === '2' ? 'grid-cols-2' : 'grid-cols-3'}`}>
        {Array.from({ length: parseInt(layout) }).map((_, colIndex) => (
          <DroppableColumn
            key={colIndex}
            rowIndex={rowIndex}
            colIndex={colIndex}
            fields={columns[colIndex]}
            onEdit={(field)=>onEdit?.(field)}
            onDeleteField={onDeleteField}
            updateFields={(updatedFields) => {
              const newCols = [...columns];
              newCols[colIndex] = updatedFields;
              updateRow(rowIndex, { layout, columns: newCols });
            }}
          />
        ))}
      </div>
    </div>
  );
}
